import React, { useEffect, useState } from "react";
import EditHeader from "../../components/EditHeader";
import { Button } from "@mui/material";
import FileUploader from "../../components/FileUploader";
import CustomTextField from "../../components/CustomTextField";
import Styles from "./games.module.scss";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchGameDetailQuery, useCreateGameMutation, useUpdateGameMutation } from '../../features/api/gameApi';
import { appendToFormData, isEmpty, validateData } from '../../helper';
import { ToastContainer, toast } from 'react-toastify';

function CreateEditGame() {
  const navigate = useNavigate();
  let { id: documentId } = useParams();
  const [image, setImage] = useState(null);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const userData = useSelector(state => state?.auth?.user);

  const { data: gameData, refetch } = useFetchGameDetailQuery(documentId);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (!documentId && !userData?.roleData['games_create']) {
      navigate('/');
    }
    if (documentId && !userData?.roleData['games_edit']) {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.roleData]);

  useEffect(() => {
    setData({ ...data, ...gameData?.data });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameData]);

  const [createGame] = useCreateGameMutation();
  const [updateGame] = useUpdateGameMutation();

  const onChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleUploadFiles = (name, files) => {
    setImage(files);
  }

  const saveChanges = async () => {
    setLoading(true);
    const errors = validateData(data, ['title', 'description']);
    if (!isEmpty(errors)) {
      setLoading(false);
      toast.error(errors, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
      });
      return true;
    }

    let postData = data;
    let formData;
    formData = appendToFormData({
      ...postData,
      image: image || data?.image,
    });
    let response = {};
    if (documentId) {
      response = await updateGame(formData);
    } else {
      response = await createGame(formData);
    }
    if (response?.data?.status) {
      setLoading(false);
      toast.success(response?.data?.message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1000,
      });
      setTimeout(() => {
        navigate('/games')
      }, 2000);
    } else {
      setLoading(false);
      toast.error(response?.data?.message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
      });
    }
  };

  return (
    <div className="container">
      <EditHeader title="Edit Game" navigateUrl="/games" />
      <div className={Styles.gameDetails}>
        <div className={Styles.gameData}>
          <CustomTextField fullWidth name="title" required value={data?.title} onChange={onChange} label='Title' placeholder='Game Title' />
          <CustomTextField fullWidth name="description" required value={data?.description} onChange={onChange} label='Description' placeholder='Game description' />
        </div>
        <div className={Styles.ImageUpload}>
          <FileUploader name="image" images={data?.image} setData={setData} data={data} fileCount={1} onFileDrop={handleUploadFiles} />
        </div>
      </div>
      <div className={Styles.saveGame}>
        <Button
          sx={{
            backgroundColor: '#7367F0', '&:hover': {
              backgroundColor: '#6056CD',
            }, color: '#ffffff', padding: '8px 20px',
            marginLeft: 'auto'
          }}
          onClick={() => saveChanges()}
          disabled={loading}
        >
          Save Changes
        </Button>
      </div>
      <ToastContainer />
    </div>
  );
}

export default CreateEditGame;
